import React, { useState, useEffect } from "react";
import {
  Table,
  TableContainer,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Box,
  TextField,
  Grid,
  styled,
} from "@mui/material";

const StyledTableCellHeader = styled(TableCell)(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.primary.contrastText,
  fontSize:'1.5em',
  // textAlign: 'center',
}));

const StyledTableCellBody = styled(TableCell)(() => ({
  fontSize:'1em',
  // textAlign: 'center',
}));

const TableComponent = ({ columns, rows }) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedTitle, setSelectedTitle] = useState("");

  useEffect(() => {
    // Obtendo o título da URL quando o componente monta
    const params = new URLSearchParams(window.location.search);
    const title = params.get('title');

    // Verifica se o título existe e se contém um ponto (.)
    if (title && title.includes('.')) {
        const trimmedTitle = title.split('.')[0]; // Obtém o texto antes do ponto
        setSelectedTitle(trimmedTitle);
       setSearchTerm(trimmedTitle); // Define o termo de pesquisa
    } else {
        setSelectedTitle(title); // Define o título sem alterações
    }
}, []);
 
  useEffect(() => {
    // Define o valor do campo de pesquisa quando o título da URL mudar
    setSearchTerm(selectedTitle);
  }, [selectedTitle]);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    setPage(0); // Reset page when search term changes
  };

  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  }));

  //se o searchTerm estiver vazio não aplica nenhum filtro e retorna todas as linhas
  const filteredRows = rows.filter((row) =>
  columns.some((column) => {
    const value = String(row[column.id]);
    return !searchTerm || value.toLowerCase().includes(searchTerm.toLowerCase());
  })
);

  const paginationLabels = {
    labelRowsPerPage: "Linhas por página:",
    labelDisplayedRows: ({ from, to, count }) =>
      `${from}-${to} de ${count}`,
  };

  return (
    <Box my={1}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6} xl={6}>
          {/* Deixe este item vazio para criar um espaço à direita */}
        </Grid>
        <Grid item xs={12} md={6} xl={6}>
          <TextField
            label="Pesquisar"
            variant="outlined"
            onChange={handleSearchChange}
            value={searchTerm}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} md={12} xl={12}>
          <TableContainer>
            <Table sx={{ minWidth: 700, borderRadius: "5%" }} aria-label="customized table">
              <TableHead>
                <StyledTableRow>
                  {columns.map((column, index) => (
                    <StyledTableCellHeader key={index} align={column.align || 'center'}>
                      {column.label}
                    </StyledTableCellHeader>
                  ))}
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {filteredRows
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, rowIndex) => (
                    <StyledTableRow key={rowIndex}>
                      {columns.map((column, colIndex) => (
                        <StyledTableCellBody key={colIndex} align={column.align || 'center'}>
                          {row[column.id]}
                        </StyledTableCellBody>
                      ))}
                    </StyledTableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            {...paginationLabels}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TableComponent;
